const footer = {
    policies : "법적 정책",
    privacy : "개인정보처리방침",
    clinic_terms : "클리닉 서비스 약관",
    app_terms : "앱 서비스 약관",
    contact : "연락처",
    social : "소셜네트워크"
};

export default footer;